import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import { useLocation, Link } from "react-router-dom";
import styled from "styled-components";
import { TabList, Tab } from "sprout-ui-dom/dist/Tabs";
import { Flex } from "sprout-ui-primitives";
const Wrapper = styled(Flex)`
  position: sticky;
  top: 0;

  background: rgba(253, 246, 240, 1);
  width: 100%;
  margin-bottom: 24px;

  &:after {
    z-index: 1;
    position: absolute;
    top: 100%;
    content: " ";
    right: 0;
    left: 0;
    height: 48px;
    background: linear-gradient(
      to bottom,
      rgba(253, 246, 240, 1),
      rgba(253, 246, 240, 0)
    );
  }
`;
const PoliciesPageNavTabList = styled(TabList)`
  padding: 0 16px;
  overflow-x: auto;

  min-height: 48px;
  height: auto;
`;
const PoliciesPageNav = ()=>{
    const { pathname  } = useLocation();
    const getIndex = useCallback(()=>{
        switch(pathname){
            case "/terms":
                return 0;
            case "/privacy":
                return 1;
            case "/copyright":
                return 2;
            case "/trademark":
                return 3;
            default:
                return 4;
        }
    }, [
        pathname
    ]);
    const [index, setIndex] = useState(getIndex());
    const handleChange = useCallback((_event, nextIndex)=>{
        setIndex(nextIndex);
    }, []);
    return /*#__PURE__*/ _jsx(Wrapper, {
        align: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(PoliciesPageNavTabList, {
            index: index,
            onChange: handleChange,
            children: [
                /*#__PURE__*/ _jsx(Tab, {
                    as: Link,
                    to: "/terms",
                    children: "Terms"
                }),
                /*#__PURE__*/ _jsx(Tab, {
                    as: Link,
                    to: "/privacy",
                    children: "Privacy"
                }),
                /*#__PURE__*/ _jsx(Tab, {
                    as: Link,
                    to: "/copyright",
                    children: "Copyright"
                }),
                /*#__PURE__*/ _jsx(Tab, {
                    as: Link,
                    to: "/trademark",
                    children: "Trademark"
                }),
                /*#__PURE__*/ _jsx(Tab, {
                    as: Link,
                    to: "/community",
                    children: "Community"
                })
            ]
        })
    });
};
export default PoliciesPageNav;
